import AboutPageFooter from 'components/v2/modules/about-lp/about-page-footer';
import AboutPageHeader from 'components/v2/modules/about-lp/about-page-header';

const AboutPageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <AboutPageHeader />
      <div className="all-font-sans">{children}</div>
      <AboutPageFooter />
    </>
  );
};

export default AboutPageLayout;
